module.exports = __webpack_public_path__ + "static/media/game-bosstalkingright.9c41e227.png";